// extracted by mini-css-extract-plugin
export default {"inspectorContentRoot":"InspectorContent_inspectorContentRoot__NXVro","imgContainer":"InspectorContent_imgContainer__AItx8","zoom":"InspectorContent_zoom__EOb7s"};